import { css, createGlobalStyle } from "styled-components";

import * as colors from "./colors";

const selection = (color: string) => css`
  background: ${color};
  color: white;
`;

// tslint:disable
export const BaseStyle = createGlobalStyle`

  *, *:before, *:after {
    box-sizing: border-box;
  }

  ::-moz-selection {
    ${selection(colors.link)}
  }

  ::selection {
    ${selection(colors.link)}
  }

  .icon-link {
    display: none;
  }

  .btn-link {
    color: rgb(50, 90, 180);
    cursor: pointer;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // color: #34495e;
    background-color: #fff;
  }

  body {
    color: transparent;
  }

  body > *, #root {
    color: ${colors.text};
  }

  html, body, #root {
    height: 100vh;
    min-height: 100vh;
  }

  body.with-overlay,
  body.with-overlay #root {
    overflow: hidden;
  }

  a, a:visited, a:active {
    text-decoration: none;
    color: ${colors.link};
    word-break: break-all;
  }

  a:hover {
    color: ${colors.link};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: color 9999s ease-out, background-color 9999s ease-out;
    transition-delay: 9999s;
  }

  input:required,
  input:invalid {
    box-shadow: none;
  }

  button:focus {
    outline: none !important;
  }

  select {
    color: ${colors.text};
  }

  pre, code {
    max-width: 100%;
    overflow-x: auto;
    font-size: 13px;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;

    &.react-prism {
      &[class*="language-"] {
        font-size: 13px;
        line-height: 20px;
        margin-bottom: 20px;
      }
    }

    .token {
      font-size: 13px;
      max-width: 100%;
      white-space: normal;
      word-wrap: break-word;
      word-break: break-all;
    }
  }

  em {
    color: #818181;
    -webkit-font-smoothing: antialiased;
  }

  li {
    color: #2c3f51;
    line-height: 22px;
    font-size: 15px;
    margin: 10px 0;

    &>p {
      padding-top: 0;
    }
  }

  ul {
    color: ${colors.primary};
    ul {
      margin: 0;
    }
  }

  ol {
    margin-block-start: 0;
    padding-inline-start: 1em;
  }

  p {
    line-height: 22px;
    font-size: 15px;
    padding-top: 10px;
    margin: 0;
    color: #2c3f51;
    // word-spacing: 0.05em;
  }

  strong {
    color: #222;
  }

  b {
    font-weight: 600;
  }

  .h5-flow {
    width: 300px!important;
  }

  .overview-flow {
    height: auto;
  }
`;
